module.exports = __webpack_public_path__ + "static/media/location-soil.8ebe485d.png";